import styled from 'styled-components';

export const Box = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.palette.primary.border};
  background-color: ${({ theme }) => theme.palette.primary.background};
  padding: 20px 15px;
`;
